import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { refreshTokens, logout } from "../../features/login/loginSlice";
import CookiesManager from "../../common/utils/cookies";

import config from "../../config";
const { envs } = config;
const { login: apiPath } = config.endpoints;

const baseQuery = fetchBaseQuery({
 baseUrl: envs.apiUrl + envs.apiPrefix,
 prepareHeaders: (headers, { getState }) => {
  const access_token = getState().loginReducer.access_token;
  if (access_token) {
   headers.set("Authorization", `Bearer ${access_token}`);
  }
  return headers;
 },
});

const { readCookie } = CookiesManager;
const refreshQuery = async () => {
 const { refresh_token, access_token } = readCookie("userData");
 const params = { ...envs.keycloak, grant_type: "refresh_token", refresh_token: refresh_token };

 const body = Object.keys(params)
  .map((key) => {
   return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
  })
  .join("&");

 const response = await fetch(
  envs.apiUrl + envs.apiPrefix + apiPath.userLogin,
  {
   method: "POST",
   headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${access_token}`,
   },
   body: body,
   mode: "cors",
  }
 );
 try {
  const data = await response.json();
  if (data?.error || data?.error_description) {
   throw new Error(data?.error + data?.error_description || "");
  }
  return { data };
 } catch (error) {
  return { error };
 }
};

const baseQueryWithReauth = async (args, api, extraOptions) => {
 let result = await baseQuery(args, api, extraOptions);
 if (result.error && result.error.status === 401) {
  // try to get a new token
  const refreshResult = await refreshQuery();
  if (refreshResult.data) {
   // store the new token
   api.dispatch(refreshTokens(refreshResult.data));
   // retry the initial query
   result = await baseQuery(args, api, extraOptions);
  } else {
   api.dispatch(logout());
  }
 }
 return result;
};

export default baseQueryWithReauth;
